import { MODAL_TYPES, ModalControllerInterface } from "../../../entities/Modal";
import ModalAlert from "../ModalComponents/ModalAlert";
import ModalConfirmation from "../ModalComponents/ModalConfirmation/ModalConfirmation";
import ModalProductPreview from "../ModalComponents/ModalProductPreview";
import ModalSwitchRecipeType from "../ModalComponents/ModalSwitchRecipeType";

// TODO: Rethink Modal Mechanism
export const ModalController: ModalControllerInterface[] = [
  {
    type: MODAL_TYPES.PRODUCT_PREVIEW,
    component: <ModalProductPreview />,
  },
  {
    type: MODAL_TYPES.ALERT,
    component: <ModalAlert />,
  },
  {
    type: MODAL_TYPES.CONFIRMATION,
    component: <ModalConfirmation />,
  },
  {
    type: MODAL_TYPES.SWITCH_RECIPE_TYPE,
    component: <ModalSwitchRecipeType />,
  },
];
